var strategy = function(){
    return Promise.resolve();
}

export default strategy;


//////////////////
// WEBPACK FOOTER
// ./src/strategies/no-op-behaviour.js
// module id = 7
// module chunks = 0